const config = {
  apiGateway: {
    REGION: 'us-east-1',
    INTERNAL_API_URL: 'https://bimc6bnxlg.execute-api.us-east-1.amazonaws.com/prod',
    COMPANY_API_URL: 'https://6ldpldyjxj.execute-api.us-east-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'master',
    HOSTNAME: 'https://company.staging.rossing.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.rossing.forwoodsafety.com',
    WEBSOCKET: 'wss://ywkefmoqw1.execute-api.us-east-1.amazonaws.com/staging'
  },
};

export default config;